var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatabricks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12423_29216)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 24.9385C19.1274 24.9385 24.5 19.5659 24.5 12.9385C24.5 6.31106 19.1274 0.938477 12.5 0.938477C5.87258 0.938477 0.5 6.31106 0.5 12.9385C0.5 19.5659 5.87258 24.9385 12.5 24.9385ZM12.5 19.2407L2.5 14.5765L2.50091 11.3395L3.01222 11.1085L12.5 15.5785L21.4765 11.3762V9.68123L12.5 13.8437L2.5 9.18098V8.64098L12.5 3.93848L20.1271 7.52273V7.94723L19.5226 8.25548L12.5 4.97948L4.03575 8.94923L12.5 12.919L22.0339 8.44748L22.5 8.67848V11.8787L12.5 16.5422L3.57059 12.3797V14.0372L12.5 18.277L22.0339 13.8055L22.5 14.0372V17.275L12.5 21.9385L2.50091 17.2735V16.696L3.01222 16.465L12.5 20.935L21.4765 16.7357V15.0782L12.5 19.2407Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12423_29216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.938477)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabricks);
export default __webpack_public_path__ + "static/media/databricks.26efacdd6eaa59095c555bcf53e1a1cb.svg";
export { ForwardRef as ReactComponent };